<template>
  <div>
    <el-form ref="formRef" :model="setsForm" label-width="140px">
      <el-form-item label="平台：">
        <el-radio-group v-model="platformType" @change="platformTypeChange" :disabled="setsForm.state > 0">
          <el-radio :label="1" size="large">安卓</el-radio>
          <el-radio :label="4" size="large">鸿蒙</el-radio>
          <el-radio :label="2" size="large">苹果</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="包名：">
        <el-select v-model="packageNameId" placeholder="Select" :disabled="setsForm.state > 0">
          <el-option v-for="item in packageNameArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="版本：">-->
<!--        <el-radio-group v-model="isSvip" @change="isSvipChange">-->
<!--          <el-radio :label="1" size="large">新版SVIP</el-radio>-->
<!--          <el-radio :label="0" size="large">旧版星级</el-radio>-->
<!--        </el-radio-group>-->
<!--      </el-form-item>-->
      <el-form-item label="版本：">
        <el-radio-group v-model="versionState" @change="versionStateChange">
          <el-radio :label="1" size="large">旧版VIP</el-radio>
          <el-radio :label="2" size="large">4.2版本及以上</el-radio>
<!--          <el-radio :label="3" size="large">4.5版本及以上</el-radio>-->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="支付方式：" v-if="platformType != 2 && versionState > 1">
        <el-radio-group v-model="payMode" @change="payModeChange">
          <el-radio :label="1" size="large">支付宝</el-radio>
          <el-radio :label="2" size="large">微信</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="类型：">
        <el-radio-group v-model="payType" :disabled="versionState == 1 || payMode == 2" @change="payTypeChange">
          <el-radio :label="1" size="large">普通</el-radio>
          <el-radio :label="2" size="large">自动续费</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="展示包类型：" v-if="payMode == 1">
        <div>
          <el-radio-group v-model="isSpecialPackage">
            <el-radio :label="0" size="large">全部包</el-radio>
            <el-radio :label="1" size="large">特定包</el-radio>
            <el-radio :label="2" size="large">非特定包</el-radio>
          </el-radio-group>
          <div v-if="isSpecialPackage == 1" style="font-size: 12px; color: #aaaaaa; line-height: 1.5">
            <p v-for="(item, index) in wechatPayPackageSpecialHand" :key="index" >{{index+1}}、{{item}}</p>
          </div>
        </div>

      </el-form-item>
      <el-form-item label="渠道：" v-if="platformType == 2">
        <el-input type="text" placeholder="10字以内" v-model="setsForm.channel"  style="width:25em" :disabled="platformType == 1 || platformType == 4" />
        <p style="color: red; font-size: 12px;" v-show="platformType == 1 || platformType == 4">目前Android、鸿蒙端统一婚恋服务套餐,暂不支持区分渠道</p>
      </el-form-item>
      <el-form-item label="苹果id：" v-if="platformType == 2">
        <el-input type="text" placeholder="10字以内" v-model="setsForm.productId"  style="width:25em" :disabled="platformType == 1 || platformType == 4" />
      </el-form-item>
      <el-form-item label="商品名称：">
        <el-input type="text" placeholder="请输入商品名称" v-model="setsForm.name" style="width:25em"  />
      </el-form-item>
      <el-form-item label="说明：">
        <el-input type="text" placeholder="请输入说明" v-model="setsForm.oldPrice" style="width:25em"  />
      </el-form-item>
      <el-form-item label="标签内容：">
        <el-input type="text" placeholder="10个字以内" v-model="setsForm.tag"  style="width:25em;"  />
<!--        <el-checkbox v-model="checked">不显示标签</el-checkbox>-->
      </el-form-item>
      <el-form-item label="支付价格：">
        <el-input type="text" placeholder="请输入支付价格" v-model="setsForm.price" style="width:25em"  />
      </el-form-item>
      <el-form-item label="账单名称：">
        <el-input type="text" placeholder="请输入账单名称" v-model="setsForm.billName" :maxlength="20" style="width:25em"></el-input>
      </el-form-item>
      <el-form-item label="性别：">
        <el-radio-group v-model="sex">
          <el-radio :label="0" size="large">不限</el-radio>
          <el-radio :label="1" size="large">男</el-radio>
          <el-radio :label="2" size="large">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input type="number" v-model.number="orderNum" min="1" placeholder="数字越大越靠前"  style="width:25em"/>
      </el-form-item>
      <el-form-item label="会员类型：">
        <el-radio-group v-model="type">
          <el-radio :label="1" size="large">普通会员</el-radio>
          <el-radio :label="2" size="large">终身会员</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="vip时长：" v-if="type == 1">
        <el-input v-model="expireTime" placeholder="请输入vip时长" style="width:25em;" :disabled="(setsForm.state == 1 || setsForm.state == 2) && payType == 2">
          <template #suffix>
            <span>天</span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="免费试用天数：" v-if="payType == 2">
        <el-input v-model="setsForm.freeDay" placeholder="请输入免费试用天数" style="width:25em;" />
        <p style="color: red; font-size: 13px">*0元体验赠送的会员天数</p>
      </el-form-item>
<!--      <el-form-item label="服务时长：">-->
<!--        <el-select v-model="expireTime" placeholder="请选择"  style="width: 18em;margin-right: 16px;">-->
<!--          <el-option v-for="item in expireList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--        <span v-for="item in matcherNumList" :key="item.id"><span v-show="expireTime == item.value">牵线次数：{{item.label}}</span></span>-->
<!--      </el-form-item>-->
      <el-form-item label="新人状态：">
        <el-radio-group v-model="newuserShow">
          <el-radio :label="0" size="large">全部</el-radio>
          <el-radio :label="1" size="large">新用户</el-radio>
          <el-radio :label="2" size="large">非新用户</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="SVIP状态：">
        <el-radio-group v-model="svipShow">
          <el-radio :label="0" size="large">全部</el-radio>
          <el-radio :label="1" size="large">已开通过SVIP会员</el-radio>
          <el-radio :label="2" size="large">未开通过SVIP会员</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="可见用户类型：">
        <el-radio-group v-model="isFocusUser">
          <el-radio :label="0" size="large">全部</el-radio>
          <el-radio :label="2" size="large">关注用户</el-radio>
          <el-radio :label="1" size="large">未关注用户</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </div>

</template>

<script>
import {getFormData, postFormData} from "@/api/api"
import {addOrUpdateMarriage, getCommonSysParam} from "@/api/url";
import { negativeDecimal, positiveIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "SetsDialog",
  props: {
    value: Object
  },
  data() {
    return {
      setsForm: this.value.setsForm,
      idx: this.value.ids,

      // isSvip: this.value.ids > -1? this.value.setsForm.isSvip: 1,
      versionState: this.value.ids > -1? this.value.setsForm.versionState: 1,
      payType: this.value.ids > -1? this.value.setsForm.payType: 1,
      newuserShow: this.value.ids > -1? this.value.setsForm.newuserShow: 0,
      svipShow: this.value.ids > -1? this.value.setsForm.svipShow: 0,
      isFocusUser: this.value.ids > -1? this.value.setsForm.isFocusUser: 0,
      type: this.value.ids > -1? this.value.setsForm.type: 1,
      payMode: this.value.setsForm.payMode?this.value.setsForm.payMode:0,
      isSpecialPackage: this.value.setsForm.isSpecialPackage?this.value.setsForm.isSpecialPackage:0,
      platformType: this.value.ids > -1? this.value.setsForm.platformType: 1,
      packageNameId: this.value.ids > -1? this.value.setsForm.packageNameId: 0,
      orderNum: this.value.ids > -1? this.value.setsForm.orderNum: 1,

      sexList: [
        { label: '男', value: 1 },
        { label: '女', value: 2 }
      ],
      sex: this.value.ids > -1?this.value.setsForm.sex:1,

      // expireList: [
      //   { label: "3个月", value: 8035200 },
      //   { label: "6个月", value: 16070400 },
      //   { label: "1年", value: 32140800 },
      //   { label: "3年", value: 96422400 }
      // ],
      // matcherNumList: [
      //   { label: "12", value: 8035200 },
      //   { label: "24", value: 16070400 },
      //   { label: "48", value: 32140800 },
      //   { label: "144", value: 96422400 }
      // ],
      expireTime: this.value.setsForm.expireTime?this.value.setsForm.expireTime/(24*3600):'',
      checked: this.value.setsForm.tag?false: true,

      // 平台
      // platformList: [
      //   {label: 'Android', value: 1},
      //   {label: 'iOS', value: 2},
      //   {label: '鸿蒙', value: 4},
      // ],
      // platform: 1

      wechatPayPackageSpecialHand: '',

      channelPackageList: this.value.channelPackageList,
      packageNameArray: [{label:'不限', value: 0}],

    }
  },
  methods: {

    payTypeChange(val) {
      // if(val == 2) {
      //   this.isSpecialPackage = 0
      // }
    },

    platformTypeChange(val) {
      if(val == 2) {
        this.payMode = 0
      }

      this.packageNameArray = [{label:'不限', value: 0}];
      this.channelPackageList.map(item=>{
        if(item.platformType == val) {
          let obj = {}
          obj.label = item.packageName
          obj.value = item.id
          this.packageNameArray.push(obj)
        }
      })
    },

    payModeChange(val) {
      if(val == 2) {
        this.payType = 1
        this.isSpecialPackage = 0
      }
    },

    versionStateChange(val) {
      if(val == 1) {
        this.payType = 1
        this.payMode = 0
      }
    },

    cancel() {
      this.$emit("close");
    },

    submit() {
      if(this.platformType != 2 && this.versionState > 1 && !this.payMode) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择支付方式',
          type: 'warning'
        });
        return false
      }

      if (!(negativeDecimal.test(this.setsForm.price))) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: "价格需要为正实数，最多两位小数",
          type: 'warning'
        })
        return false;
      }
      if (!this.setsForm.billName) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: "请输入账单名称",
          type: 'warning'
        })
        return false;
      }
      if (!this.setsForm.name) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: "请输入商品名称",
          type: 'warning'
        })
        return false;
      }
      if (!this.orderNum) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: "排序不能为空或小于0",
          type: 'warning'
        })
        return false;
      }
      if (!this.setsForm.channel && this.platformType == 2) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: "请输入渠道",
          type: 'warning'
        })
        return false;
      }
      if (!this.setsForm.productId && this.platformType == 2) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: "请输入苹果id",
          type: 'warning'
        })
        return false;
      }
      let param = {}
      param['id'] = this.idx == -1?0: this.setsForm.id;
      param['sex'] = this.sex;
      param['channel'] = this.platformType == 2?this.setsForm.channel:'app';
      param['productId'] = this.platformType == 2?this.setsForm.productId:0;
      // this.matcherNumList.forEach(item => {
      //   if(item.value == this.expireTime) {
      //     param['matcherNum'] = item.label;
      //   }
      // });
      param['name'] = this.setsForm.name;
      param['type'] = this.type;
      param['expireTime'] = this.type == 1?this.expireTime*(24*3600):0;
      param['freeDay'] = this.setsForm.freeDay && this.payType == 2?this.setsForm.freeDay:0;
      param['tag'] = this.setsForm.tag;
      param['price'] = this.setsForm.price;
      param['oldPrice'] = this.setsForm.oldPrice;
      param['billName'] = this.setsForm.billName;
      param['orderNum'] = this.orderNum;
      param['platformType'] = this.platformType;
      param['packageNameId'] = this.packageNameId;
      param['newuserShow'] = this.newuserShow;
      param['svipShow'] = this.svipShow;
      param['payType'] = this.payType;
      param['versionState'] = this.versionState;
      param['payMode'] = this.payMode;
      param['isSpecialPackage'] = this.isSpecialPackage;
      param['isFocusUser'] = this.isFocusUser;
      postFormData(addOrUpdateMarriage, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    getCommon() {
      getFormData(getCommonSysParam).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          this.wechatPayPackageSpecialHand = data.data.wechatPayPackageSpecialHand.split(',')
        }
      })
    },

  },

  mounted() {
    this.getCommon()
    if(this.idx < 0) {
      this.payMode = 1
    } else {
      this.platform = this.setsForm.platformType;
    }

    this.channelPackageList.map(item=>{
      if(item.platformType == this.platformType) {
        let obj = {}
        obj.label = item.packageName
        obj.value = item.id
        this.packageNameArray.push(obj)
      }
    })
  }
}
</script>

<style scoped>

</style>
